import { trServer } from "./i18n";

// The rule of a player's name (backend/player_profile.py, clean_name), checked before asking the
// server: the guest forms (Landing, JoinRoom) and the profile popup. Its messages are the server's
// own French sentences, translated the same way (lib/i18n/server.js).
export const NAME_MAX = 20;

// As the server keeps it: spaces folded.
export const foldName = (s) => (s || "").replace(/\s+/g, " ").trim();

// Counted in characters, like the server (an emoji is one).
export const nameLength = (s) => [...s].length;

/** What is wrong with that name, ready to show, or null. */
export function nameError(raw) {
  const name = foldName(raw);
  if (!name) return trServer("Le nom est requis");
  if (nameLength(name) < 2) return trServer("Le nom doit faire au moins 2 caractères");
  if (nameLength(name) > NAME_MAX) return trServer("Le nom ne peut pas dépasser 20 caractères");
  if (/^bot\s*\d*$/i.test(name)) return trServer("Ce nom est réservé aux bots");
  return null;
}
